import React, { useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import InputTextField from "../../../components/input/inputTextField";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import {
  NavigateNext,
  RemoveRedEyeOutlined,
  SearchOutlined,
} from "@mui/icons-material";
import { ButtonPrimary } from "../../../components/button/ButtonCustoms";
import SwitchCustom from "../../../components/switch/SwitchCustom";
import { dateTimeToView } from "../../../utils/date.utils";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../components/alert/swal";
import { debouncedApiCall } from "../../../utils/app.utils";
import { advisorFileApi } from "../../../api/advisor-file/advisor-file.api";
import { advisorFormApi } from "../../../api/advisor-form/advisor-form.api";
import { icons } from "../../../assets/icons/icons";
import { useTranslation } from "react-i18next";

type Props = {};

const ManageEvaluationForm: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState<any[]>([]);
  const [singleData, setSingleData] = useState<any>({});

  const [search, setSearch] = useState<string>("");

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const getEvaluationForm = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
    };

    if (search) query = { ...query, search: search };

    const res = await advisorFormApi.getAllAdvisorForm(query);
    const data = res.data;
    if (data.status < 300) {
      console.log("data.data.items", data.data.items);
      setData(data.data.items);
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
    } else {
      setData([]);
    }
  };

  const handleUpdateStatusDocument = async (id: number, status: string) => {
    await advisorFormApi
      .updateAdvisorFormStatus(id, status)
      .then((res) => {
        if (res.status < 300) {
          dispatch(unsetLoading());
          alertSuccess(
            t("แก้ไขสถานะ"),
            t("แก้ไขสถานะ เรียบร้อยแล้ว"),
            undefined,
            () => {
              dispatch(unsetLoading());
              getEvaluationForm();
            }
          );
        }
      })
      .catch(() => {
        alertError(t("แก้ไขสถานะ ไม่สำเร็จ"));
      })
      .finally(() => {
        dispatch(unsetLoading());
      });
  };

  const headCells = [
    {
      id: "form_name",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: t("ชื่อแบบฟอร์ม"),
    },
    {
      id: "usage_type",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: t("ใช้สำหรับ"),
    },
    // {
    //   id: "is_form_start",
    //   width: 50,
    //   sortable: false,
    //   disablePadding: false,
    //   align: "start",
    //   label: "ใช้เป็นฟอร์มเริ่มต้น",
    // },
    {
      id: "status",
      disablePadding: false,
      width: 5,
      sortable: false,
      align: "center",
      label: t("สถานะ"),
    },
    {
      id: "created_date",
      disablePadding: false,
      align: "center",
      width: 15,
      label: t("ผู้สร้าง/ปรับปรุงล่าสุด"),
    },
    {
      id: "modified_date",
      disablePadding: false,
      align: "center",
      width: 50,
      label: t("วันที่สร้าง/ปรับปรุงล่าสุด"),
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "",
    },
  ];

  const prepareDataForApi = (data: any) => {
    const nameChecked: string[] = []; // Initialize as an array

    // Check if is_advisor is not "0" and push the name if true
    if (data.is_advisor !== "0") {
      nameChecked.push(t(data.is_advisor));
    }

    // Check if is_class_room is not "0" and push the name if true
    if (data.is_class_room !== "0") {
      nameChecked.push(t(data.is_class_room));
    }

    // Check if is_teacher is not "0" and push the name if true
    if (data.is_teacher !== "0") {
      nameChecked.push(t(data.is_teacher));
    }

    // Join the names into a single string, separated by commas
    return nameChecked.join(", ");
  };
  const handleDelete = async (id: number) => {
    if (id) {
      alertActive(
        t("ลบรูปแบบฟอร์ม"),
        t("ท่านต้องการลบรูปแบบฟอร์ม ใช่หรือไม่"),
        undefined,
        undefined,
        async () => {
          dispatch(setLoading());
          await advisorFormApi
            .deleteAdvisorForm(+id)
            .then((res) => {
              if (res.status < 300) {
                alertSuccess(
                  t("ลบรูปแบบฟอร์ม เรียบร้อย"),
                  undefined,
                  undefined,
                  () => {
                    getEvaluationForm();
                  }
                );
              }
            })
            .catch(() => {
              alertError(t("รูปแบบฟอร์ม ไม่สำเร็จ"));
            })
            .finally(() => {
              dispatch(unsetLoading());
            });
        }
      );
    }
    return;
  };

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_advisor_form,
      advisor_form_name,
      is_class_room,
      is_teacher,
      is_advisor,
      status,
      modified_by,
      modified_date,
    } = objData;

    const objRenderData = {
      key: id_advisor_form,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: advisor_form_name,
        },
        {
          option: "TEXT",
          align: "start",
          label: prepareDataForApi(objData),
        },
        // {
        //   option: "TEXT",
        //   align: "start",
        //   label: is_teacher,
        // },
        {
          option: "TEXT",
          align: "center",
          label: (
            <div className="w-full flex justify-center ">
              <SwitchCustom
                checked={status === "active" ? true : false}
                onChange={(value: boolean) => {
                  handleUpdateStatusDocument(
                    id_advisor_form,
                    value ? "active" : "inactive"
                  );
                }}
              />
            </div>
          ),
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: modified_by || '-',
        },
        {
          option: "TEXT",
          align: "center",
          label: modified_date ? dateTimeToView(modified_date) : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <div
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <RemoveRedEyeOutlined
                onClick={() => {
                  navigate(
                    routeName.cms.ManageEvaluationForm + `/${id_advisor_form}`
                  );
                }}
                style={{
                  cursor: "pointer",
                }}
              />
              <img
                src={icons.bag_cross}
                alt="bag_cross"
                style={{ cursor: "pointer", marginLeft: "12px" }}
                onClick={() => {
                  handleDelete(id_advisor_form);
                }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  useEffect(() => {
    getEvaluationForm();
  }, [page, pageLimit, sortBy, sortType, search]);

  return (
    <div>
      <ContentHeading
        title={t("จัดการแบบฟอร์มประเมิน")}
        detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder={t("ค้นหาชื่อแบบฟอร์ม")}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>

        <article
          className="w-full col-span-12 md:col-span-4 lg:col-span-9 sm:col-span-12"
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <ButtonPrimary
            onClick={() => {
              navigate(routeName.cms.CreateEvaluationForm);
            }}
            mode="add"
            buttonName={t("เพิ่มแบบฟอร์ม")}
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default ManageEvaluationForm;
